import { alpha, ThemeOptions } from "@mui/material";

export const MuiCard: NonNullable<ThemeOptions["components"]>["MuiCard"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: theme.tokens.radius.xl,
      backgroundColor: theme.palette.mode === "dark" ? theme.tokens.paperDark : theme.tokens.paperLight,
    }),
  },
  variants: [
    {
      props: { variant: "glass" as any },
      style: ({ theme }) => {
        const isDark = theme.palette.mode === "dark";
        const baseColor = isDark ? theme.tokens.paperLight : theme.tokens.paperDark;
        return {
          background: alpha(baseColor, isDark ? 0.12 : 0.72),
          backdropFilter: `blur(${theme.tokens.overlay.glassBlur}px)`,
          border: `${theme.tokens.borders.thin}px solid ${alpha(baseColor, theme.tokens.overlay.glassBorderOpacity)}`,
        };
      },
    },
  ],
};

export const MuiCardActionArea: NonNullable<ThemeOptions["components"]>["MuiCardActionArea"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: "100%",
      borderRadius: `${theme.tokens.radius.xl}px`,
    }),
  },
};

export const MuiCardHeader: NonNullable<ThemeOptions["components"]>["MuiCardHeader"] = {
  styleOverrides: {
    content: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(theme.tokens.spacing.md),
    }),
  },
};

export const MuiCardMedia: NonNullable<ThemeOptions["components"]>["MuiCardMedia"] = {
  styleOverrides: {
    root: () => ({
      height: 200,
      backgroundSize: "contain",
      backgroundPosition: "center",
    }),
  },
};
